// extracted by mini-css-extract-plugin
module.exports = {"formFooter":"add_discussion_question_form-module__formFooter___1iS7L"};